import Http from '../common/http';
import ApiUtil from '../utils/api.util';

const RESOURCE = 'search';

const SearchService = {
  getInitSearchData() {
    return {
      dataSearch: {
        country: [],
        region: [],
        department: [],
        source: [],
        newsletter: [],
        gender: null,
        birthYearFrom: null,
        birthYearTo: null,
        delegate: []
      },
      dataFilter:[
        this.getInitFilter()
      ]
    }
  },
  getInitFilter(){
    return {
          yearBackToSchool: [],
          diploma: [],
          objectiveSpecialities: [],
          themes: [],
          studyLevel: [],
          channel: []
        };
  },
  getInitSaveData() {
    return {
      searchInfo: null,
      searchCriteria: null,
      searchResult: null,
      searchTotal: null,
      studentIds: []
    }
  },
  search(form) {
    return Http.post(`/${RESOURCE}`, form);
  },
  save(form) {
    return Http.post(`/${RESOURCE}/save`, form);
  },
  loadSearch(invoiceId){
    return Http.get(`/${RESOURCE}/load-search/${invoiceId}`);
  }
};

export default SearchService;
